import { TradeWayRadioButtons } from 'components/shared/ButtonsGroup/TradeWayRadioButtons';
import { ValidationFeedbackMessage } from 'components/shared/FormGroup/ErrorMessages';
import { useIsInternalUser } from 'hooks/useIsInternalUser';
import { FC } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { isQuoteTypeWithExecOnly } from 'state/quotes/utils';
import { getFormQuoteResult, getSidePanelTradeWay, getTradeConfirmation } from 'state/selectors';
import { AppState } from 'state/state.model';
import { updateSidePanelMetadata } from 'state/uiPanelState/sidePanelUi/sidePanelUi.action';
import { QuoteWorkspaceType } from 'state/workspaces/model';

export interface TradeWaySwitchProps {
  e2e?: string;
  tabId: string;
  workspaceType: QuoteWorkspaceType;
}

export const TradeWaySwitch: FC<TradeWaySwitchProps> = ({ e2e, workspaceType, tabId }) => {
  const isInternalUser = useIsInternalUser();
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const tradeWay = useSelector((state: AppState) => getSidePanelTradeWay(state, tabId));

  const { isTrading, hadTraded } = useSelector((state: AppState) => getTradeConfirmation(state, workspaceType, tabId));
  const quoteResult = useSelector((state: AppState) => getFormQuoteResult(state, workspaceType, tabId));
  const isExecOnly = quoteResult?.quoteType !== undefined && isQuoteTypeWithExecOnly(quoteResult.quoteType);
  const isTradedOneWay = quoteResult?.tradeDirection === 'OneWay';
  const shouldShowErrorMessage = tradeWay === undefined && isInternalUser;

  const shouldHideTradeWaySwitch = isTrading || hadTraded || isTradedOneWay || isExecOnly;

  if (shouldHideTradeWaySwitch) {
    return null;
  }

  return (
    <div data-e2e={e2e} className="mx-3 mt-3">
      <TradeWayRadioButtons
        className="w-100"
        tradeWay={tradeWay ?? 'Sell'}
        isDisabled={!isInternalUser}
        onSelect={tradeWay => dispatch(updateSidePanelMetadata(tabId, { tradeWay }))}
      />
      {shouldShowErrorMessage && (
        <ValidationFeedbackMessage
          validationError={{
            severity: 'Warning',
            message: formatMessage({ id: 'quote.errorMessages.missingDefaultTradeWay' }),
          }}
        />
      )}
    </div>
  );
};
